<div class="card-body pt-0 mt-n5">
  <div class="text-center">
    <div class="profile-user position-relative d-inline-block mx-auto">
      
      @if (imageLoading) {
        <!-- Loading spinner for image -->
        <div class="avatar-lg rounded-circle d-flex align-items-center justify-content-center bg-light">
          <div class="spinner-border spinner-border-sm" role="status">
            <span class="visually-hidden">Loading...</span>
          </div>
        </div>
      } @else {
        <!-- Profile image -->
        <img 
          [src]="profileImage" 
          [alt]="userName" 
          [id]="'user-img-' + componentId"
          class="avatar-lg rounded-circle object-fit-cover border-0 img-thumbnail user-profile-image"
          (click)="onProfileClick()"
          (error)="onImageError($event)">
      }
      
      @if (allowImageUpload && !imageLoading) {
        <div class="avatar-xs p-0 rounded-circle profile-photo-edit position-absolute end-0 bottom-0">
          <input 
            [id]="'profile-img-file-input-' + componentId" 
            type="file" 
            class="profile-img-file-input d-none" 
            accept="image/*"
            (change)="onFileChange($event)">
          <label 
            [for]="'profile-img-file-input-' + componentId" 
            class="profile-photo-edit avatar-xs">
            <span class="avatar-title rounded-circle bg-light text-body">
              <i class="bi bi-camera"></i>
            </span>
          </label>
        </div>
      }
    </div>
    
    <div class="mt-3">
      <h5>
        {{ userName }} 
        @if (isVerified) {
          <i class="bi bi-patch-check-fill align-baseline text-info ms-1"></i>
        }
      </h5>
    </div>
  </div>
</div>